<template>
  <ul class="c-entrepreneur-video-decorative">
    <entrepreneur-video-decorative-item v-for="(icon, index) in icons" :key="index" :icon="icon" />
  </ul>
</template>

<script>
import EntrepreneurVideoDecorativeItem from "components/EntrepreneurVideo/EntrepreneurVideoDecorative/EntrepreneurVideoDecorativeItem";
export default {
  components: {
    EntrepreneurVideoDecorativeItem
  },

  data() {
    return {
      icons: [
        { iconName: "arrow-down", className: "mobile" },
        { iconName: "arrow-up-right", className: "top" },
        { iconName: "arrow-up-right", className: "bottom" }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.c-entrepreneur-video-decorative {
  position: relative;
  width: 100%;
  height: 100%;
  order: 1;
  display: flex;
  justify-content: center;
  margin-bottom: var(--grid-gutter-double);
  @media #{$breakpoint-horizontal} {
    position: absolute;
    top: 0px;
    order: 2;
    margin-bottom: 0px;
  }
}
</style>
